import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { GridCellBaseComponent } from '../grid-cell-base/grid-cell-base.component';
import { GridContextPermissions } from '../../../../../features/bizzmine/widgets/collection-list-widget/classes/grid-context-permissions';
import { GridService } from '../../../../../features/bizzmine/widgets/collection-list-widget/services/grid/grid.service';
import { ContextMenuService } from '../../../../services/context-menu/context-menu.service';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { TaskService } from '../../../../services/tasks/task.service';
import { TrainingApiService } from '../../../../../api/bizzmine/training/training-api.service';
import { Dialog } from '@angular/cdk/dialog';
import { IconComponent } from '../../../ui/icon/icon.component';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';
import { TranslatePipe } from '../../../../pipes/translate/translate.pipe';
import { ChangeDetectionService } from 'src/app/core/services/change-detection/change-detection.service';

@Component({
  selector: 'bizz-grid-cell-answer-actions',
  standalone: true,
  imports: [
    IconComponent,
    TooltipDirective,
    TranslatePipe
  ],
  templateUrl: './grid-cell-answer-actions.component.html',
  styleUrl: './grid-cell-answer-actions.component.scss'
})
export class GridCellAnswerActionsComponent extends GridCellBaseComponent<unknown>
  implements OnInit {
  @ViewChild('menuIcon') public menuIcon!: ElementRef;
  @Input() public set readOnly(value: boolean) {
    this._readonly = value;
    this.onDataChanged();
  }

  private _readonly: boolean = false;

  protected permissions: GridContextPermissions;

  public constructor(private gridService: GridService, private contextMenuService: ContextMenuService,
                     private store$: Store, private router: Router,
                     private taskService: TaskService,
                     private trainingApiService: TrainingApiService,
                     private dialog: Dialog) {
    super();
  }

  public ngOnInit(): void {
    this.permissions = new GridContextPermissions();
    this.onDataChanged();
  }

  public override onDataChanged(): void {
    if(this.permissions && this.metaData && this.data) {
      this.permissions.loadActionPermissions(this.metaData, this.data, this._readonly);
      this.permissions.loadMenuPermissions(this.data, this._readonly);
    }
    ChangeDetectionService.detectChanges(this.changeDetectorRef);
  }

  protected onOpenClicked(event: MouseEvent): void {
    const newTab = event && (event.ctrlKey || event.metaKey);
    this.gridService.readInstance(this.data.CollectionsID, this.data.ID, this.data.VersionsID, this.data.GuidChecksum, this.data.DraftsID, this.data.OriginalFoldersID, true, this.metaData.trashFilterActive, newTab);
  }

  protected onActionMenuIconClick(event: MouseEvent): void {
    this.contextMenuService.open(this.permissions, this.data, this.menuIcon, true, this.metaData.widgetId, this.metaData.listOptions.ListID);
  }

  protected onEditClicked(event: MouseEvent): void {
    const newTab = event && (event.ctrlKey || event.metaKey);
    this.gridService.editInstance(this.data.CollectionsID, this.data.ID, this.data.VersionsID, this.data.GuidChecksum, this.data.DraftsID, this.data.OriginalFoldersID, undefined, undefined, newTab);
  }


}
